import { render, staticRenderFns } from "./EditSocialAgent.vue?vue&type=template&id=5521889b&scoped=true&"
import script from "./EditSocialAgent.vue?vue&type=script&lang=js&"
export * from "./EditSocialAgent.vue?vue&type=script&lang=js&"
import style0 from "./EditSocialAgent.vue?vue&type=style&index=0&id=5521889b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5521889b",
  null
  
)

export default component.exports